import { axisClasses } from "@mui/x-charts/ChartsAxis";

type CartesianChartData = {
  xLabel: string;
  yLabel: string;
  abbreviatedContent: Array<{ [key: string]: any }>;
  series: { dataKey: string; label: string; color: string }[];
};

export const getCartesianChartData = (
  content: Array<{ [key: string]: any }>,
  xAxisKey: string,
  colorPalette: Array<string>,
  yAxisKey?: string,
): CartesianChartData => {
  let abbreviatedContent = content.map((item) => ({
    ...item,
    [xAxisKey]: item[xAxisKey]?.substring(0, 3), // substring first 3 chars to fit in chart
  }));

  const xLabel = toTitleCase(xAxisKey);
  const yLabel = toTitleCase(yAxisKey || "");

  const series = Object.keys(abbreviatedContent[0])
    .filter((key) => key !== xAxisKey)
    .map((key, index) => ({
      dataKey: key,
      label: toTitleCase(key),
      color: colorPalette[index % colorPalette.length],
    }));

  return { xLabel, yLabel, abbreviatedContent, series };
};

export const toTitleCase = (str: string) => {
  return str
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, (char: string) => char.toUpperCase()); // Capitalize first letter of each word
};

export const defaultColorPalette = [
  "#A78D75", // dark pastel brown
  "#A3A49A", // dark pastel olive-gray
  "#6E4F75", // dark pastel mauve
  "#4E6D5C", // dark pastel green
  "#5A4B66", // dark pastel lavender-gray
];

export const cartesianChartStyling = {
  sx: {
    [`.${axisClasses.left} .${axisClasses.label}`]: {
      transform: "translate(-40px, 0)",
    },
  },
};
